export const PROGRAMS = [
  {
    key: "BA LLB",
    label: "BA LLB",
    tagline: "An Integrated Approach To Legal And Social Sciences Education",
    overview:
      "A 5-Year Integrated Law Program Combining Legal Studies With Subjects From The Social Sciences. The Program Introduces Students To Constitutional Law, Public Law, Advocacy, And Legal Research, Along With Practical Exposure Through Moots, Seminars, And Internships From The Early Stages Of Study.",
    details: [
      "Duration: 5 Years",
      "Eligibility: As Per Applicable Admission Criteria",
      "Mode: Full-Time (Offline)",
      "Location: Worli, South Mumbai",
    ],
    structure: [
      "Interdisciplinary Curriculum Integrating Law And Social Sciences",
      "Focus On Constitutional Studies, Advocacy, And Legal Research",
      "Moot Courts, Debates, Legal Aid Clinics, And Seminars",
      "Structured Internships And Practical Legal Exposure",
      "Sessions And Guest Lectures By Legal Professionals And Practitioners",
    ],
    pathways: [
      "Litigation And Judiciary Preparation",
      "Corporate Legal And Compliance Roles",
      "Civil Services And Public Policy",
      "Academia And Legal Research",
      "Internship And Placement Assistance Across Legal Sectors",
    ],
    support: [
      "Admission Process As Per University Guidelines",
      "Access To Legal Research Platforms Including Manupatra And SCC Online",
      "Academic Mentoring And Guidance",
      "Legal Aid Activities And Field Visits",
      "Co-Curricular And Competition-Based Learning Opportunities",
    ],
  },
  {
    key: "LLB",
    label: "LLB",
    tagline: "A Focused Study Of Substantive And Procedural Law",
    overview:
      "A 3-Year Postgraduate Law Program Designed For Graduates Seeking A Structured Understanding Of Legal Systems, Procedures, And Practice. The Program Combines Academic Learning With Practical Legal Exposure Through Moot Courts, Internships, Court Visits, And Legal Aid Initiatives.",
    details: [
      "Duration: 3 Years",
      "Eligibility: Graduate In Any Discipline",
      "Mode: Full-Time (Offline)",
      "Location: Worli, South Mumbai",
    ],
    structure: [
      "Foundation In Substantive And Procedural Laws",
      "Practical Orientation Through Moot Courts And Court Visits",
      "Legal Research And Case Law Analysis",
      "Access To Manupatra And SCC Online Databases",
      "Internship Opportunities And Legal Aid Activities",
    ],
    pathways: [
      "Litigation And Judiciary Pathways",
      "Corporate Legal And Policy Roles",
      "Compliance And Regulatory Functions",
      "Legal Research And Academic Opportunities",
      "Placement Guidance And Internship Assistance",
    ],
    support: [
      "Admission Process As Per University Guidelines",
      "Access To Legal Research Resources And Academic Support",
      "Mentoring And Practical Exposure Initiatives",
      "Guest Lectures, Seminars, And Field-Based Activities",
      "Co-Curricular Learning Opportunities",
    ],
  },
  {
    key: "LLM",
    label: "LLM",
    tagline: "Advanced Legal Study With A Focus On Research And Specialisation",
    overview:
      "A Postgraduate Law Program Designed For Advanced Study In Specialised Areas Of Law, With Emphasis On Legal Research, Interpretation, And Academic Development. The Program Supports Students Interested In Higher Legal Studies, Academia, Policy Research, And Specialised Professional Practice.",
    details: [
      "Duration: As Per University Structure",
      "Eligibility: LL.B. Graduate",
      "Mode: Full-Time (Offline)",
      "Location: Worli, South Mumbai",
    ],
    structure: [
      "Advanced Legal Studies And Specialised Subjects",
      "Research-Oriented Academic Framework",
      "Legal Analysis And Interpretation",
      "Access To Academic And Legal Research Resources",
      "Seminars, Discussions, And Academic Engagement",
    ],
    pathways: [
      "Higher Legal Research And Academia",
      "Specialised Legal Practice",
      "Policy And Regulatory Research",
      "Corporate Advisory And Legal Consulting",
      "Academic And Professional Development Opportunities",
    ],
    support: [
      "Admission Process As Per University Guidelines",
      "Access To Legal Databases And Research Support",
      "Academic Mentoring And Faculty Guidance",
      "Seminar Participation And Research Exposure",
      "Student Support Initiatives And Academic Resources",
    ],
  },
];
